<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
    *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="valve-info">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <img ngSrc="/assets/img/zone_icons/light/{{zones.selectedZone.description.styleIcon}}.svg"
                    width="45" height="45" alt="" />
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
               {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                    data-testid="back-button"
                    (click)="zones.goBack()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                        width="40" height="40" alt="" />
                </div>
            </div>

            <div class="dropdown-list dropdown-list--info">
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(1040) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedZone.tile.params.returnTemp | format:7 }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(1161) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedZone.tile.params.openingPercentage | format:8 }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(464) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name"
                            *ngIf="zones.selectedZone.tile.params.boilerProtection == 1">
                            {{ subtitle(3498) }}
                        </p>
                        <p class="dropdown-list__value-name"
                            *ngIf="zones.selectedZone.tile.params.boilerProtection != 1">
                            {{ subtitle(922) }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(465) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name"
                            *ngIf="zones.selectedZone.tile.params.returnProtection == 1">
                            {{ subtitle(3498) }}
                        </p>
                        <p class="dropdown-list__value-name"
                            *ngIf="zones.selectedZone.tile.params.returnProtection != 1">
                            {{ subtitle(922) }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(1005) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                           {{ zones.selectedZone.tile.params.setTempCorrection | format:6 }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(585) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                           {{ zones.selectedZone.tile.params.valvePump == 0 ? subtitle(922) : subtitle(950) }}
                        </p>
                    </div>
                </div>
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(973) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zones.selectedZone.tile.params.valveNumber }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
